import * as yup from "yup"
import {
  getFieldMessages,
  fullNameField,
  phoneField,
  requiredTextField,
  checkboxField,
  type FormLanguage,
} from "../../common/forms"

export function createSchema(language: FormLanguage, checkboxRequired: boolean) {
  const m = getFieldMessages(language)

  return yup.object({
    fullName: fullNameField(m),
    phone: phoneField(m),
    cityOfResidence: requiredTextField(m),
    checkbox: checkboxField(m, checkboxRequired),
  })
}

export type FormValues = yup.InferType<ReturnType<typeof createSchema>>

export const defaultValues: FormValues = {
  fullName: "",
  phone: "",
  cityOfResidence: "",
  checkbox: false,
}
